export const NAME = 'chat' as const;

export const CONVERSATION_TEXTS = {
  START_CONVERSATION: 'Start the conversation saying hello...',
  HOLD_BUTTON: 'Speak while holding the button pressed...',
  HAS_ENDED: 'The conversation has ended...',
};
